import Axios from 'axios'
import EventBus from './bus'
import Vue from 'vue'
import { EVENT_USER_TOKEN_SET, EVENT_USER_UNSET, EVENT_USER_TOKEN_TIMEOUT } from './stores/current-user'
import _ from 'lodash'

EventBus.$on(
    EVENT_USER_TOKEN_SET,
    _ => {Axios.defaults.headers.common['Authorization'] = `Bearer ` + Vue.$jwt.getToken()}
)

EventBus.$on(
    EVENT_USER_UNSET,
    _ => delete Axios.defaults.headers.common['Authorization']
)

export default class ApiMiddleware {
    constructor(baseUrl = '') {
        this.baseUrl = baseUrl
    }

    async get(path) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await Axios.get(`${this.baseUrl}${path}`)
                resolve(_.get(response, 'data.data'))
            } catch (e) {
                const code = _.get(e, 'response.status')
                if (code === 401) {
                    EventBus.$emit(EVENT_USER_TOKEN_TIMEOUT)
                    localStorage.clear()
                    location.path = '/app'
                }
            }
        })
    }

    async post(path, data) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await Axios.post(`${this.baseUrl}${path}`, data)
                resolve(_.get(response, 'data.data'))
            } catch (e) {
                const code = _.get(e, 'response.status')
                if (code === 401) {
                    // EventBus.$emit(EVENT_USER_TOKEN_TIMEOUT)
                    localStorage.clear()
                    location.path = '/app'
                }
                reject(e)
            }
        })
    }

    async put(path, data) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await Axios.put(`${this.baseUrl}${path}`, data)
                resolve(_.get(response, 'data.data'))
            } catch (e) {
                const code = _.get(e, 'response.status')
                if (code === 401) {
                    EventBus.$emit(EVENT_USER_TOKEN_TIMEOUT)
                    localStorage.clear()
                    location.path = '/app'
                }
                reject(e)
            }
        })
    }

    async delete(path) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await Axios.delete(`${this.baseUrl}${path}`)
                resolve(_.get(response, 'data.data'))
            } catch (e) {
                const code = _.get(e, 'response.status')
                if (code === 401) {
                    EventBus.$emit(EVENT_USER_TOKEN_TIMEOUT)
                    localStorage.clear()
                    location.path = '/app'
                }
                reject(e)
            }
        })
    }

}
